<template>
    <el-drawer
        :visible.sync="show"
        :wrapperClosable="false"
        title="选择轮播图"
        direction="rtl"
        size="600px"
        :before-close="close">
        <div class="panel fx-g1">
            <el-tabs v-model="activeTab" class="fx-g1 fx-col inner_tags-page">
                <el-tab-pane label="总部图库" name="centerLib">
                    <el-table
                        ref="lib2Table"
                        :data="centerLib"
                        stripe
                        style="width: 100%;overflow: auto;"
                        @selection-change="handleCenterPicChoose"

                    >
                        <el-table-column
                            type="selection"
                            width="55">
                        </el-table-column>
                        <el-table-column
                            min-width="120"
                            label="" >
                            <template slot-scope="scope">
                                <img :src="scope.row.value" style="width: 500px; height: 220px">
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="本校区图库" name="schoolLib">
                    <el-table
                        ref="libTable"
                        :data="selfLib"
                        stripe
                        style="width: 100%;overflow: auto;"
                        @selection-change="handleSelfPicChoose"

                    >
                        <el-table-column
                            type="selection"
                            width="55">
                        </el-table-column>
                        <el-table-column
                            min-width="120"
                            label="" >
                            <template slot-scope="scope">
                                <img :src="scope.row.value" style="width: 500px; height: 220px">
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

            </el-tabs>


        </div>
        <span  class="fx fx-center" style="position: relative">
            <div v-if="activeTab=='schoolLib' && user.institution.pid==0 && !isSub" style="position: absolute;left: 10px;top: 10px">
                <span style="margin:0 10px;color: #2b3736">子机构是否可见库 </span>
                <el-switch v-model="form.allowSubUse"
                           inactive-color="#ff4949">
                </el-switch>
            </div>
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>

    import {mapState} from 'vuex';
    export default {
        props: [
            "item", //配置
            "isSub", //是否是在给子校区配置轮播图
        ],
        data() {
            return {
                activeTab: 'centerLib',
                show: false,
                centerLib:[],
                selfLib:[],
                form: {
                    allowSubUse: this.item.allowSubUse,
                    centerChoosedPic:[],
                    selfChoosedPic:[],
                },

            }

        },
        computed: {
            ...mapState({
                user: state => state.user
            })
        },

        methods: {
            close() {
                this.$emit("close");
            },
            sub() {
                if (this.activeTab == 'schoolLib') {
                    this.$emit("submit", {
                        allowSubUse: this.form.allowSubUse, //子机构是否可见库
                        pics: this.form.selfChoosedPic.map(item => item.value)
                    });
                } else {
                    this.$emit("submit", {
                        pics: this.form.centerChoosedPic.map(item => item.value)
                    });
                }

                return false;
            },
            handleCenterPicChoose(val) {
                this.form.centerChoosedPic = val;
            },
            handleSelfPicChoose(val) {
                this.form.selfChoosedPic = val;
            },
            loadData() {
                //加载总部图库
                if (this.user.institution.pid ) { //子机构读取父机构和总部的库
                    this.$ajaxGet("/dictionary/listCenterAndParentProgramBannerLib", data => {
                        this.centerLib = data.result;
                    })
                } else {

                    this.$ajaxGet("/dictionary/listCenterProgramBannerLib", data => {
                        this.centerLib = data.result;
                    })
                }
                //加载本校区图库
            	this.$ajaxGet("/dictionary/listSelfProgramBannerLib", data => {
                    this.selfLib = data.result;
                })

            }

        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadData();
        }


    }
</script>
